// fields that are common across slots like entry id displayed at top of detailed booking form.
export enum COMMON_FIELD_IDS {
    ENTRY_NUMBER_FIELD = 'entry-number-field',
    BRAND_FIELD = 'brand-field',
    AE_NAME_FIELD = 'ae-name-field',
    CATEGORY_FIELD = 'category-field',
    TYPE_OF_PURCHASE_FIELD = 'type-of-purchase-field',
};

export const COMMON_FIELD_ID_ARRAY: string[] = Object.values(COMMON_FIELD_IDS);
